import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: '2025-06-24', // Use today's date or your preferred version
  useCdn: false, // Always fetch fresh data in dev
  token: process.env.SANITY_API_TOKEN, // Only needed if you want to update content
});

// Set up image URL builder
const builder = imageUrlBuilder(client);

export function urlFor(source: any) {
  return builder.image(source);
}

// Notification configuration query
export async function getNotificationConfig() {
  try {
    const query = `*[_type == "notificationBar"][0] {
      showNotificationBar,
      notificationText,
      notificationCTA {
        text,
        href
      }
    }`;
    
    const result = await client.fetch(query);
    return result || {
      showNotificationBar: true,
      notificationText: "Join our Newsletter!",
      notificationCTA: {
        text: "",
        href: "/newsletter"
      }
    };
  } catch (error) {
    console.error('Error fetching notification config:', error);
    // Return default values if Sanity is not available
    return {
      showNotificationBar: true,
      notificationText: "Join our Newsletter!",
      notificationCTA: {
        text: "",
        href: "/newsletter"
      }
    };
  }
}

// Fetch terms page content from Sanity
export async function getTermsPage() {
  const query = `*[_type == "termsPage"][0]{
    title,
    content,
    lastUpdated
  }`;
  return await client.fetch(query);
} 